import type { VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "../cn";
import { buttonVariants as button } from "./button-variants";

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof button> {
  children?: ReactNode;
}

/** A button. Says exactly what happens when pressed. */
export function Button({ className, variant, size, weight, ...props }: ButtonProps) {
  return <button className={cn(button({ variant, size, weight }), className)} {...props} />;
}
